module.exports = __webpack_public_path__ + "static/media/moorewille.140a6611.jpg";